// Resident tutorial. Designed against the older-adult guidelines rather than our own habits:
//
//  1. The two golden rules are Simplify, and increase the size and distance between
//     interactive controls. So: four screens, one idea each, 60px targets, generous gaps.
//  2. Older users READ onboarding instead of skipping it, so the words matter more here than
//     anywhere else in the product. Short sentences, no jargon, no ambiguity.
//  3. Clear, objective, educational language WITHOUT being condescending. Someone who already
//     feels unsure about technology is made worse by cheerfulness. No exclamation marks, no
//     reassurance they did not ask for, no baby talk. Plain adult sentences.
//  4. Enhance the difference between touchable and non-touchable elements through clear
//     boundaries, because cognitive strain makes that distinction harder.
//  5. Help must be easy to find, because this is the group most likely to look for it.
window.RESIDENT_TUTORIAL = {
  role: 'Resident',
  lead: 'Four things worth knowing.',

  screens: [
    {
      id: 'what',
      n: '1',
      title: 'Someone to talk to',
      body: 'You can talk to Atlas whenever you like. About your day, your family, what you used to do, or nothing in particular. It answers, and it remembers.',
      points: [
        'You can speak, or you can type.',
        'There is no right thing to say.',
        'It does not mind repetition.',
      ],
      note: 'Nobody is required to use this. If you would rather not, say so once and it will stop asking.',
    },
    {
      id: 'remembers',
      n: '2',
      title: 'It remembers you',
      body: 'Most of these things forget you between conversations. This one does not. It keeps what you tell it, so next week it still knows your daughter\u2019s name and that your knee troubles you in the mornings.',
      points: [
        'You will not have to explain yourself twice.',
        'You can ask it what it remembers.',
        'You can ask it to forget something.',
      ],
      note: 'What it keeps is about you and it stays with you. It is not for sale and it is not shown to anyone you have not agreed to.',
    },
    {
      id: 'who',
      n: '3',
      title: 'Who can see what you say',
      body: 'Nobody, until you say otherwise. Every kind of sharing starts switched off. If you want your daughter to see how you are doing, you turn that on, and you can turn it off again.',
      points: [
        'Family see nothing until you allow it.',
        'You choose what they see.',
        'You can change your mind at any time.',
      ],
      note: 'The staff here see what they need to look after you, and no more than that. If you want to know exactly what someone can see, ask, and you will be shown.',
    },
    {
      id: 'worry',
      n: '4',
      title: 'If something sounds wrong',
      body: 'If you say something that suggests you are unwell, unsafe, or being treated badly, a person here is told. Not a machine deciding on its own, a person who reads it and decides what to do.',
      points: [
        'It cannot keep a serious worry to itself.',
        'A person always reads it.',
        'You will not be in trouble for saying it.',
      ],
      note: 'This is the one thing it will not keep private, and it is the reason it is worth talking to.',
    },
  ],

  end: {
    title: 'That is everything',
    lines: [
      'Talk to it when you feel like it. Ignore it when you do not.',
      'It will still be there next week, and it will still remember.',
    ],
    ask: 'If you want any of this explained again, ask a member of staff, or ask Atlas itself.',
    cta: 'Start talking',
  },
};
